exports.EmployeesPageView = require('./EmployeesPageView').default;
exports.ApplicantsPageView = require('./ApplicantsPageView').default;
exports.EmployeesCreatePageView = require('./EmployeesCreatePageView').default;
exports.EmployeesUpdatePageView = require('./EmployeesUpdatePageView').default;
exports.EmployeesDetailPageView = require('./EmployeesDetailPageView').default;
exports.EmployeesUpdateRolesPageView = require('./EmployeesUpdateRolesPageView').default;
